module.exports = __webpack_public_path__ + "static/media/054-hourglass.157e3a65.svg";